export const PRESENTATION = {
  BOLD: "bold",
  LINK: "link",
  BOLD_LINK: "bold_link",
  NONE: "none",
};

export const PRESENTATION_FIELD = {
  DISEASE_NAME: "diseaseName",
  REGIMEN_TITLE: "regimenTitle",
  COURSE_TITLE: "courseTitle",
};

const getPresentations = (regimen) => {
  const hasDiseaseName = !!regimen.diseaseName;
  const hasRegimenTitle = !!regimen.regimenTitle;
  const hasCourseTitle = !!regimen.courseTitle;
  const hasSubRegimens = !!regimen.subRegimens?.length;

  if (hasSubRegimens) {
    return {
      [PRESENTATION_FIELD.DISEASE_NAME]: PRESENTATION.BOLD,
      [PRESENTATION_FIELD.REGIMEN_TITLE]: PRESENTATION.NONE,
      [PRESENTATION_FIELD.COURSE_TITLE]: PRESENTATION.BOLD_LINK,
    };
  }

  if (hasDiseaseName && hasRegimenTitle && !hasCourseTitle) {
    return {
      [PRESENTATION_FIELD.DISEASE_NAME]: PRESENTATION.BOLD_LINK,
      [PRESENTATION_FIELD.REGIMEN_TITLE]: PRESENTATION.BOLD_LINK,
      [PRESENTATION_FIELD.COURSE_TITLE]: PRESENTATION.NONE,
    };
  }

  return {
    [PRESENTATION_FIELD.DISEASE_NAME]: PRESENTATION.BOLD_LINK,
    [PRESENTATION_FIELD.REGIMEN_TITLE]: PRESENTATION.LINK,
    [PRESENTATION_FIELD.COURSE_TITLE]: PRESENTATION.BOLD_LINK,
  };
};

export const getFieldPresentation = (regimen, fieldName) => {
  const presentations = getPresentations(regimen);
  return presentations[fieldName];
};
